export default __webpack_public_path__ + "static/media/theFactorsKaren.628e7fed.wav";